interface ExpandCollapseIconProps {
  className?: string;
}

const ExpandCollapseIcon = ({ className = '' }: ExpandCollapseIconProps) => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M4 6L8 10L12 6'
      stroke='#6B7280'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default ExpandCollapseIcon;
